import { SITE } from "../../data/content";

// Floating WhatsApp button — visible on every page
export default function WhatsAppFab() {
  return (
    <a
      href={SITE.whatsappHref}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed z-[60] bottom-20 right-4 sm:bottom-24 sm:right-7 flex items-center gap-2 sm:gap-3 shadow-lg pl-3 pr-4 sm:pl-4 sm:pr-5 py-2.5 sm:py-3 transition-transform hover:-translate-y-0.5"
      style={{
        background: "#25D366",
        color: "#FFFFFF",
        borderRadius: 999,
        fontFamily: "Outfit, sans-serif",
      }}
    >
      <svg width="20" height="20" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" className="sm:w-[22px] sm:h-[22px]">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.092-.832-2.335-.214-.515-.355-.575-.918-.575-.272 0-.544-.027-.818-.027-.475 0-.797.473-.797.99 0 1.504 1.103 2.835 2.115 3.937 1.6 1.736 3.638 3.246 5.872 3.972.302.103 1.106.247 1.354.247.404 0 .9-.142 1.176-.36.302-.235.502-.7.502-1.06 0-.327-.117-.49-.354-.59-.327-.137-1.16-.46-1.474-.46zM16.13 5.5c-5.804 0-10.5 4.696-10.5 10.5 0 2.064.6 4.064 1.736 5.793l-2.04 6.077 6.286-2.014a10.46 10.46 0 0 0 4.518 1.144c5.804 0 10.5-4.696 10.5-10.5S21.934 5.5 16.13 5.5zm0 19.07c-1.434 0-2.84-.382-4.07-1.106l-.295-.176-3.027.97.985-2.952-.193-.305a8.547 8.547 0 0 1-1.31-4.5c0-4.74 3.857-8.57 8.57-8.57s8.57 3.83 8.57 8.57c0 4.74-3.857 8.57-8.57 8.57z" />
      </svg>
      <span className="hidden sm:inline text-sm font-medium tracking-wide">WhatsApp Us</span>
      <span className="sm:hidden text-xs font-medium tracking-wide">WhatsApp</span>
    </a>
  );
}
